import Sortable from 'sortablejs'
import type { Ref } from 'vue'
import { onBeforeUnmount, watch } from 'vue'

import type { TableReorderEvent } from './types'

type UseSortableRowsOptions = {
  tbodyRef: Ref<HTMLElement | null>
  enabled: Ref<boolean>
  onReorder: (event: TableReorderEvent) => void
}

export function useSortableRows({ tbodyRef, enabled, onReorder }: UseSortableRowsOptions) {
  let sortableInstance: Sortable | null = null

  function init() {
    destroy()
    if (!tbodyRef.value || !enabled.value) return

    sortableInstance = Sortable.create(tbodyRef.value, {
      handle: '[data-sortable-handle]',
      animation: 150,
      delay: 300,
      delayOnTouchOnly: true,
      ghostClass: 'ltable-sortable-ghost',
      onEnd(event) {
        if (event.oldIndex != null && event.newIndex != null && event.from) {
          const { from, oldIndex, newIndex } = event
          const children = [...from.children]
          const movedEl = children[newIndex]
          const referenceEl = children[oldIndex]
          if (oldIndex < newIndex) {
            from.insertBefore(movedEl, referenceEl)
          } else {
            from.insertBefore(movedEl, referenceEl.nextSibling)
          }
          onReorder({ oldIndex, newIndex })
        }
      }
    })
  }

  function destroy() {
    if (sortableInstance) {
      sortableInstance.destroy()
      sortableInstance = null
    }
  }

  watch([tbodyRef, enabled], () => {
    if (enabled.value && tbodyRef.value) {
      init()
    } else {
      destroy()
    }
  })

  onBeforeUnmount(destroy)
}
